<script setup lang="ts">
import { computed } from 'vue'

import type { KanbanComment } from '@entities/kanban-comment'

import { KanbanComments } from '@widgets/kanban-comments'
import { useKanbanCommentsStore } from '@entities/kanban-comment'
import { useOnTimezoneChange } from '@entities/viewer'

import { parseFilterParams } from '../model/task-comments/filter-params'
import { useCustomerTaskCommentsApi } from '../api/task-comments/comments.hook'
import { useUpdateCustomerTaskCommentApi } from '../api/task-comments/update-comment.hook'

defineOptions({
  name: 'CustomerTaskCommentsPage',
})

const route = useRoute()
const customerId = computed<string>(() => route.params.id as string)

const kanbanCommentsStore = useKanbanCommentsStore()

useOnTimezoneChange(() => {
  const filters = parseFilterParams(route.query)
  void useCustomerTaskCommentsApi({
    customerId: customerId.value,
    disciplineId: filters.discipline_id,
    createdFrom: filters.created_from,
    createdTo: filters.created_to,
    team: filters.team,
    taskType: filters.task_type,
  })
})

const updateCommentApi = (commentId: number, comment: string): Promise<KanbanComment | null> => {
  const existing = kanbanCommentsStore.getComments.find(item => item.id === commentId)
  const taskId = existing?.kanban_task?.id
  if (!taskId) return Promise.resolve(null)
  return useUpdateCustomerTaskCommentApi({ taskId, commentId, comment })
}
</script>

<template>
  <KanbanComments
    title="Task comments"
    additional-data
    :update-api="updateCommentApi"
  />
</template>
